import React from 'react';

const Loader = () => {
  return <div className="fh5co-loader"></div>;
};

export default Loader;
